import { FavouriteData, FavouriteRequest, FavouriteSearchParams } from './favorite.type';

export const addFavourite = (data: FavouriteRequest) => apiClient().post('/listing/add-to-favourite', data);

export const removeFavourite = (data: FavouriteRequest) => apiClient().post('/listing/remove-from-favourite', data);

export const getFavouriteListings = (data: FavouriteSearchParams) =>
  apiClient().get<FavouriteData[]>('/listing/get-favourite-listings', { params: data });
